import React from 'react';

const LandingPage: React.FC = () => (
  <div className="min-h-screen bg-sbp-surface flex flex-col">
    <header className="bg-brand-navy text-white px-3 py-2 flex items-center justify-between">
      <div className="flex items-center gap-3">
        <span className="text-[11px] font-semibold px-2 py-0.5 rounded bg-white/10 text-white border border-white/30">
          MEO Audit
        </span>
      </div>
      <img
        src="/Clariveil.png"
        alt="Clariveil"
        style={{ height: '32px', width: 'auto', objectFit: 'contain' }}
      />
    </header>
    <main className="flex-1 flex flex-col items-center justify-center px-6 py-16 text-center">
      <h1 className="text-3xl font-bold text-slate-900 mb-3">パーソナルジム特化 MEO 診断</h1>
      <p className="text-sm text-slate-600 max-w-md leading-relaxed mb-8">
        Google マップ検索結果における競合ポジションを可視化し、
        貴店専用の改善提案をお届けします。<br />
        共有URLをお持ちの方は、いただいたリンクから直接アクセスしてください。
      </p>
      <a
        href="mailto:yuichao@clariveil.com"
        className="inline-flex items-center gap-2 px-5 py-2.5 bg-slate-900 text-white text-sm rounded-lg hover:bg-slate-800"
      >
        お問い合わせ
      </a>
    </main>
    <footer className="py-4 text-center text-xs text-slate-400 border-t border-slate-200 bg-white">
      © {new Date().getFullYear()} Clariveil
    </footer>
  </div>
);

export default LandingPage;
